export function toInputDate(value) {
  if (!value) return "";
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) {
    const s = String(value);
    return s.length >= 10 ? s.slice(0, 10) : "";
  }
  return d.toISOString().slice(0, 10);
}

export function fmtDate(value) {
  if (!value) return "-";
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return String(value);
  return d.toLocaleDateString();
}

export function statusClass(status) {
  const v = String(status || "").toLowerCase();

  if (["approved", "received", "completed"].includes(v)) {
    return "bg-emerald-50 text-emerald-700 border-emerald-200";
  }
  if (["pending", "pending_batch", "partially_approved"].includes(v)) {
    return "bg-amber-50 text-amber-700 border-amber-200";
  }
  if (["rejected", "cancelled", "failed"].includes(v)) {
    return "bg-rose-50 text-rose-700 border-rose-200";
  }

  return "bg-slate-50 text-slate-700 border-slate-200";
}

export function getErrorMessage(err) {
  return err?.message || "Something went wrong";
}

export function startOfToday() {
  const d = new Date();
  d.setHours(0, 0, 0, 0);
  return d;
}

export function parseDateSafe(value) {
  if (!value) return null;
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return null;
  return d;
}

export function isExpiredDate(value) {
  const d = parseDateSafe(value);
  if (!d) return false;
  return d < startOfToday();
}

export function sumQty(items = []) {
  return items.reduce(
    (sum, item) => sum + Number(item?.qty_available || item?.qtyAvailable || 0),
    0
  );
}

export function sumReservedQty(items = []) {
  return items.reduce(
    (sum, item) => sum + Number(item?.qty_reserved || item?.qtyReserved || 0),
    0
  );
}

export function sumDamagedQty(items = []) {
  return items.reduce(
    (sum, item) => sum + Number(item?.qty_damaged || item?.qtyDamaged || 0),
    0
  );
}

export function minExpiry(items = []) {
  const dates = items
    .map((item) => parseDateSafe(item?.expiry_date || item?.expiryDate))
    .filter(Boolean)
    .sort((a, b) => a.getTime() - b.getTime());

  return dates.length ? dates[0].toISOString() : null;
}

export function processStockItems(items = []) {
  return items.map((item) => {
    const batches = Array.isArray(item?.batches) ? item.batches : [];

    if (!batches.length) {
      return {
        ...item,
        qty_available: Number(item?.qty_available || 0),
        qty_reserved: Number(item?.qty_reserved || 0),
        qty_damaged: Number(item?.qty_damaged || 0),
        expired_qty: 0,
        nearest_expiry: item?.nearest_expiry || null,
        expiring_batches_count: Number(item?.expiring_batches_count || 0),
        active_batches: [],
        expired_batches: [],
      };
    }

    const activeBatches = batches.filter(
      (batch) =>
        !isExpiredDate(batch?.expiry_date) &&
        Number(batch?.qty_available || 0) > 0
    );

    const expiredBatches = batches.filter(
      (batch) =>
        isExpiredDate(batch?.expiry_date) &&
        Number(batch?.qty_available || 0) > 0
    );

    return {
      ...item,
      batches: activeBatches,
      active_batches: activeBatches,
      expired_batches: expiredBatches,
      qty_available: sumQty(activeBatches),
      qty_reserved: sumReservedQty(batches),
      qty_damaged: sumDamagedQty(batches),
      expired_qty: sumQty(expiredBatches),
      nearest_expiry: minExpiry(activeBatches),
      expiring_batches_count: activeBatches.filter((batch) => {
        const expiry = parseDateSafe(batch?.expiry_date);
        if (!expiry) return false;
        const diff = expiry.getTime() - startOfToday().getTime();
        const days = Math.ceil(diff / 86400000);
        return days >= 0 && days <= 30;
      }).length,
    };
  });
}

export function getReadableOrderId(order) {
  const rawId = order?.order_code || order?.orderCode || order?.id || "";
  if (!rawId) return "-";

  const text = String(rawId).trim();

  if (text.startsWith("WO-") || text.startsWith("ORD-")) {
    return text;
  }

  return `WO-${text.replace(/-/g, "").slice(0, 8).toUpperCase()}`;
}